import React, { useMemo } from "react";
import { CardProps } from "../../view/components/KanbanBoard/KanbanBoard";
import { Enums, UiSizes } from "../../../../../enums";
import "./_actionsKanbanCard.scss";
import { Button } from "../../../../../components/ui/Button";
import { Icon } from "@flightpath/coreui/dist/ui/Icon";
import { IconSymbols } from "../../../../../components/ui/Icon";
import { SHOW_PERSPECTIVE_MODAL } from "./ActionsKanban_modal";
import { Pill, PillTypes } from "../../../../../components/ui/Pill";
import { IF } from "../../../../../components/hoc/If";

interface CustomCardProps {
  card: CardProps;
  onDelete?: (cardId: number[], columnId: number, cardTitle: string) => void;
}

const formatDisplayDate = (date?: Date): string => {
  if (!date) return "–";
  const year = new Date(date).getFullYear();
  return year < 2020 ? "–" : new Date(date).toLocaleDateString();
};

export const ActionsKanbanCard: React.FC<CustomCardProps> = ({ card, onDelete }) => {
  const ragColor = useMemo(
    () => Enums.Translator.getCardRagColor(card.progressStatus, card.ragStatus),
    [card.progressStatus, card.ragStatus]
  );
  return (
    <div
      className="kanban-card"
      style={{ "--rag-color": ragColor } as React.CSSProperties}
      onClick={() => SHOW_PERSPECTIVE_MODAL(card)}
    >
      <Button
        className="kanban-card-delete-button "
        onClick={e => {
          e.stopPropagation();
          if (onDelete && typeof card.progressStatus === "number") {
            onDelete([card.id], card.progressStatus, card.title);
          }
        }}
      >
        <Icon symbol={IconSymbols.Close} size={UiSizes.SM} />
      </Button>
      <h4 className="kanban-card-title">{card.title}</h4>
      <IF condition={!!card.type}>
        <Pill size={UiSizes.XS} type={PillTypes.OUTLINE_PRIMARY}>
          <p className="mb-0 d-inline-block">{card.type}</p>
        </Pill>
      </IF>
      <div className="kanban-card-meta">
        <div className="d-flex mb-2 justify-content-between">
          {card.assignee && (
            <div className="d-flex flex-column justify-content-center">
              <small>Assigned To</small> {card.assignee}
            </div>
          )}
          {card.owner && (
            <div className="d-flex flex-column">
              <small>Owner</small> {card.owner}
            </div>
          )}
        </div>
        {card.endDate && (
          <div className="d-flex flex-column">
            <small>End Date</small> {formatDisplayDate(card.endDate)}
          </div>
        )}
      </div>
    </div>
  );
};
